export default __webpack_public_path__ + "assets/images/501ca0eaa04cf892b2e4249954475096.svg";